import { Plus, Trash2, Check, X, Pencil } from "lucide-react";
import { FREQ_LABEL, FREQ_ORDER } from "./constants";

// One "vínculo" card with its practices table (title edit, frequency, daily marking).
export const VinculoCard = ({
  v, days, year, month,
  editTitle, setEditTitle, savePracticeTitle, setFrequency,
  cycleCell, removePractice, addPractice,
}) => (
  <div className="bg-white border border-[hsl(var(--border))] p-6 lg:p-8" data-testid={`vinculo-${v.key}`}>
    <div className="flex items-center justify-between flex-wrap gap-3">
      <h3 className="display-heading text-xl text-[hsl(var(--primary))]">{v.label}</h3>
      <button onClick={() => addPractice(v.key)} className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-[hsl(var(--primary))] hover:text-[hsl(var(--accent))]" data-testid={`add-practice-${v.key}`}>
        <Plus className="h-3.5 w-3.5" /> Adicionar prática
      </button>
    </div>

    {v.practices.length === 0 ? (
      <p className="mt-4 text-xs italic text-[hsl(var(--muted-foreground))]">Ainda sem práticas neste vínculo.</p>
    ) : (
      <div className="mt-5 overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="border-b border-[hsl(var(--border))]">
              <th className="text-left py-2 pr-3 sticky left-0 bg-white z-10 min-w-[200px]">Prática</th>
              {days.map((d) => {
                const dow = new Date(year, month - 1, d).getDay();
                const isWeekend = dow === 0 || dow === 6;
                return (
                  <th key={d} className={`px-1 py-2 text-center font-normal ${isWeekend ? "text-[hsl(var(--accent))]" : "text-[hsl(var(--muted-foreground))]"}`}>{d}</th>
                );
              })}
              <th className="w-6" />
            </tr>
          </thead>
          <tbody>
            {v.practices.map((p) => (
              <tr key={p.id} className="border-b border-[hsl(var(--border))] last:border-0">
                <td className="py-2 pr-3 align-middle sticky left-0 bg-white z-10 min-w-[220px]">
                  <div className="flex flex-col gap-1">
                    {editTitle?.practiceId === p.id ? (
                      <input
                        autoFocus
                        value={editTitle.value}
                        onChange={(e) => setEditTitle({ ...editTitle, value: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") savePracticeTitle();
                          if (e.key === "Escape") setEditTitle(null);
                        }}
                        onBlur={savePracticeTitle}
                        className="w-full bg-white border border-[hsl(var(--accent))] px-2 py-1 text-sm focus:outline-none"
                        data-testid={`practice-title-input-${p.id}`}
                      />
                    ) : (
                      <span className="inline-flex items-center gap-1.5">
                        {p.title}
                        <button
                          onClick={() => setEditTitle({ vinculoKey: v.key, practiceId: p.id, value: p.title })}
                          title="Editar o nome da prática"
                          className="text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--accent))]"
                          data-testid={`practice-title-edit-${p.id}`}
                        >
                          <Pencil className="h-3 w-3" />
                        </button>
                      </span>
                    )}
                    <select
                      value={p.frequency || "daily"}
                      onChange={(e) => setFrequency(v.key, p, e.target.value)}
                      title="Frequência da prática"
                      className="self-start appearance-none cursor-pointer px-1.5 py-0.5 pr-5 border border-[hsl(var(--border))] bg-white text-[9px] uppercase tracking-[0.16em] text-[hsl(var(--muted-foreground))] hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] focus:outline-none focus:border-[hsl(var(--accent))]"
                      style={{ backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='3'><path d='M6 9l6 6 6-6'/></svg>\")", backgroundRepeat: "no-repeat", backgroundPosition: "right 4px center" }}
                      data-testid={`freq-${p.id}`}>
                      {FREQ_ORDER.map((f) => (
                        <option key={f} value={f}>{FREQ_LABEL[f]}</option>
                      ))}
                    </select>
                  </div>
                </td>
                {days.map((d) => {
                  const val = p.days?.[d] || "";
                  return (
                    <td key={d} className="px-0.5 py-1 text-center">
                      <button onClick={() => cycleCell(v.key, p, d)}
                        className={`h-7 w-7 inline-flex items-center justify-center border text-[10px] ${
                          val === "done" ? "bg-[hsl(var(--primary))] text-[hsl(var(--accent))] border-[hsl(var(--primary))]" :
                          val === "skip" ? "bg-[hsl(var(--secondary))] text-[hsl(var(--muted-foreground))] border-[hsl(var(--border))]" :
                          "bg-white border-[hsl(var(--border))] hover:border-[hsl(var(--accent))]"
                        }`}
                        title={val === "done" ? "Feito (clique para marcar saltado)" : val === "skip" ? "Saltado (clique para limpar)" : "Clique para marcar feito"}
                        data-testid={`cell-${v.key}-${p.id}-${d}`}
                      >
                        {val === "done" ? <Check className="h-3 w-3" /> : val === "skip" ? <X className="h-3 w-3" /> : ""}
                      </button>
                    </td>
                  );
                })}
                <td className="px-1">
                  <button onClick={() => removePractice(v.key, p.id)} className="text-[hsl(var(--muted-foreground))] hover:text-red-700" data-testid={`remove-practice-${p.id}`}>
                    <Trash2 className="h-3.5 w-3.5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
